(function () {
    'use strict';

    angular
        .module('app')
        .factory('ForecastingService', ForecastingService);

    function ForecastingService($http, $q, WebAPIUrl, WebApiService) {

        var service = {
            getPatternForecastList: getPatternForecastList,
            getProtoForecastList: getProtoForecastList,
            updateProtoForecast: updateProtoForecast,
            updatePatternForecast: updatePatternForecast,
            uploadMassPatternForecastDocument: uploadMassPatternForecastDocument,
            uploadMassPrototypeForecastDocument: uploadMassPrototypeForecastDocument,
            isLaunchNumberValid: isLaunchNumberValid,
            getLinePlanLaunchDateId: getLinePlanLaunchDateId,
            exportSalesForecast: exportSalesForecast,
            searchSalesForecast: searchSalesForecast,
            uploadSalesForecastDocument: uploadSalesForecastDocument,
            getSalesForecastSettings: getSalesForecastSettings,
            updateSalesForecastSettings: updateSalesForecastSettings,
            updateSalesForecastPairs: updateSalesForecastPairs,
            calculateSalesForecastRevenue: calculateSalesForecastRevenue,
            getSalesForecastCurrencies: getSalesForecastCurrencies
        };

        return service;

        function getPatternForecastList(searchObject) {
            return WebApiService.postJson("/api/Forecasting/GetPatternForecastList", searchObject);
        }

        function getProtoForecastList(searchObject) {
            return WebApiService.postJson("/api/Forecasting/GetProtoForecastList", searchObject);
        }

        function exportSalesForecast(so) {
            return WebApiService.postJson("/api/Forecasting/ExportSalesForecast", so, null, false);
        }

        function searchSalesForecast(so) {
            return WebApiService.postJson("/api/Forecasting/SearchSalesForecast", so);
        }

        function uploadSalesForecastDocument(file) {
            return WebApiService.postFile("/api/Forecasting/UploadSalesForecast", file);
        }

        function getSalesForecastSettings(brandId, seasonId) {
            return WebApiService.get("/api/Forecasting/SalesForecastSettings?brandId=" + brandId + "&seasonId=" + seasonId);
        }

        function updateSalesForecastSettings(models) {
            return WebApiService.postJson("/api/Forecasting/UpdateSalesForecastSettings", models);
        }

        function updateSalesForecastPairs(prototypeId, seasonId, salesRegionId, year, quarter, pairs) {
            var data = {
                prototypeId: prototypeId,
                seasonId: seasonId,
                salesRegionId: salesRegionId,
                year: year,
                quarter: quarter,
                pairs: pairs
            };

            return WebApiService.postJson("/api/Forecasting/UpdateSalesForecastPairs", data);
        }

        function calculateSalesForecastRevenue(prototypeId, seasonId, price) {
            return WebApiService.get("/api/Forecasting/CalculateSalesForecastRevenue?prototypeId=" + prototypeId + "&seasonId=" + seasonId + "&price=" + price );
        }

        function getSalesForecastCurrencies(prototypeId, seasonId) {
            return WebApiService.get("/api/Forecasting/GetSalesForecastCurrencies?prototypeId=" + prototypeId + "&seasonId=" + seasonId);
        }

        function updatePatternForecast(forecastData) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Forecasting/UpdatePatternForecast",
                data: forecastData,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function updateProtoForecast(forecastData) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Forecasting/UpdateProtoForecast",
                data: forecastData,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function uploadMassPatternForecastDocument(file) {
            var deferred = $q.defer();

            var fd = new FormData();
            fd.append('file', file);
            $http.post(WebAPIUrl + "/api/Forecasting/UploadPatternForecast", fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function uploadMassPrototypeForecastDocument(file) {
            var deferred = $q.defer();

            var fd = new FormData();
            fd.append('file', file);
            $http.post(WebAPIUrl + "/api/Forecasting/UploadPrototypeForecast", fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined },
                ignoreLoadingBar:true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }


        function isLaunchNumberValid(prototypeSeasonalId, launchNumber) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + "/api/Prototype/IsLaunchNumberValid?PrototypeSeasonalId=" + prototypeSeasonalId + "&LaunchNumber=" + launchNumber
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }


        function getLinePlanLaunchDateId(prototypeSeasonalId, launchNumber) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + "/api/Prototype/GetLinePlanLaunchDateId?PrototypeSeasonalId=" + prototypeSeasonalId + "&LaunchNumber=" + launchNumber,
                ignoreLoadingBar: true,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

    }

    }) ();
